import { useEffect, useState } from "react";
import api from "../services/api";
import { SLOT_LABELS } from "./sprintSlots";

// The sprint filter uses the 4-slot abstraction (backlog / current / next /
// bucket) rather than concrete sprint names. See docs/sprint-slots-plan.md.
const SPRINT_SLOT_FILTER_OPTIONS = ["backlog", "current", "next", "bucket"].map(
  (value) => ({ value, label: SLOT_LABELS[value] })
);

// Fetches project/epic/track option lists for the task filter controls; the
// sprint options are the fixed 4 slots.
export default function useTaskFilterOptions(workspaceId) {
  const [options, setOptions] = useState({
    sprintOptions: SPRINT_SLOT_FILTER_OPTIONS,
    projectOptions: [],
    epicOptions: [],
    trackOptions: [],
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!workspaceId) return;
    let cancelled = false;
    setLoading(true);

    const params = { params: { workspace_id: workspaceId } };
    Promise.all([
      api.get("projects/", params),
      api.get("epics/", params),
      api.get("tracks/", params),
    ])
      .then(([projectRes, epicRes, trackRes]) => {
        if (cancelled) return;
        setOptions({
          sprintOptions: SPRINT_SLOT_FILTER_OPTIONS,
          projectOptions: projectRes.data || [],
          epicOptions: epicRes.data || [],
          trackOptions: trackRes.data || [],
        });
      })
      .catch((err) => {
        if (!cancelled) console.error("Error fetching filter options:", err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  return { ...options, loading };
}
